import styles from './Info.module.scss';
import  { Html, OrbitControls } from '@react-three/drei';
import xIcon from '../../Images/close.svg'
import React, { Suspense, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { Light } from '../../Light';
import { Environment } from '@react-three/drei';
import style from '../../style.module.scss';
//import Model from '../ModelX';
import { Product } from '../../Product';
import { PerspectiveCamera } from '@react-three/drei';
//import { EffectsFx } from '../../Effects';
import { Effects } from '@react-three/drei';
import { EffectComposer, Outline, Noise, Vignette } from '@react-three/postprocessing';
import { BlendFunction, Resizer, KernelSize } from 'postprocessing'


export const Info = React.forwardRef(({position, onClickBtn, path, textInfo, name, rotation, selection }, ref7) => {


  const EffectsFx = () => {
    return(
        <>
        <EffectComposer>
        <Outline
          selection={selection} // selection of objects that will be outlined
          selectionLayer={10} // selection layer
          blendFunction={BlendFunction.SCREEN} // set this to BlendFunction.ALPHA for dark outlines
          patternTexture={null} // a pattern texture
          edgeStrength={2.5} // the edge strength
          pulseSpeed={0.0} // a pulse speed. A value of zero disables the pulse effect
          visibleEdgeColor={0xffffff} // the color of visible edges
          hiddenEdgeColor={0x22090a} // the color of hidden edges
          width={Resizer.AUTO_SIZE} // render width
          height={Resizer.AUTO_SIZE} // render height
          kernelSize={KernelSize.LARGE} // blur kernel size
          blur={false} // whether the outline should be blurred
          xRay={true} // indicates whether X-Ray outlines are enabled
        />
             <Noise opacity={0.2} />
             <Vignette eskil={false} offset={0.1} darkness={1.1} />
        </EffectComposer>
        </>
    )
}

    return(
      <>
          <div className={style['canvas-container2']}>
           
            <div  className={style['text-info']}>
              <button onPointerDown={onClickBtn} className={style['x-icon']}>x</button>
              <h3>{name}</h3>
              <div  className={style['color-devider']}>
                  <div className={style['green-devider']}></div>
                  <div className={style['green-devider']}></div>
                  <div className={style['green-devider']}></div>
              </div>
              <p className={style['text']}>
                    {textInfo} 
              </p>
            </div>
            
            <Canvas shadows>
              <PerspectiveCamera 
                makeDefault
                fov={45}
                position={[0.6, 0, 2.5]} // [0.6, 0, 4]
                rotation={rotation}
              ></PerspectiveCamera>
              <Product path={path} position={position} ref={ref7}/>
                <Environment   files={'studio_country_hall_2k.hdr'}  />
              <Light intensity={0.5}  position={[-0.2, 0.2, 4]} rotation={[4, 0 ,1]}/> 
              <OrbitControls 
                target={[0, 0, 0]}
              />
            </Canvas>
          </div>
      </>

        
    )
})







          